import { RequestInviteCodesResponse } from "../../types/invites";

export const requestInviteCodeModel = (
  response: RequestInviteCodesResponse
): RequestInviteCodesResponse => response;
